import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Container, Row } from 'reactstrap';
import moment from 'moment';

// Services
import { getSessionCookie } from '../../../../services/session';

// Components
import Header from '../../../../components/Headers/Header';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Contatnts
import { relatorioStyles } from '../../../../constants/relatorioStyles';

function RelatorioInconformidades({ handleReturn, cabecalho, relatorio }) {
    const session = getSessionCookie();

    const refImprimir = useRef();
    // Função acionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "Relatório Produtividade Sintetico",
        pageStyle: relatorioStyles
    });

    return (
        <>
            <Header />
            <Row>
                <Container className="mt--9" fluid>
                    <div className='d-flex justify-content-between align-items-center mb-1'>
                        <Button color="secondary" type="button" onClick={() => handleReturn()}>
                            Voltar
                        </Button>
                        <Button color="danger" type="button" onClick={handlePrint}>
                            <FontAwesomeIcon icon={faPrint} /> Imprimir
                        </Button>
                    </div>
                    <div className="card shadow">
                        <div className='card-body print-padding print' ref={refImprimir}>
                            <div className='row header'>
                                <div className='col-sm-12 col-lg-12 text-center print-image' style={{ display: "none" }}>
                                    <img
                                        src={require("assets/img/brand/logo.png")}
                                        alt="imagem do sistema"
                                        width={150}
                                    />
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <h2>Relatório Inconformidade</h2>
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <span className='font-weight-bold'>Modalidade de Serviço: </span> <span>{cabecalho?.modalidade ?? "Todas"}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Início:</span> <span>{cabecalho?.dataInicio && moment(cabecalho?.dataInicio).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Fim:</span> <span>{cabecalho?.dataFim && moment(cabecalho?.dataFim).format("DD/MM/YYYY")}</span>
                                </div>
                            </div>
                            <div className='row'>
                                <div className={"mt-3 col-sm-12 col-lg-12"}>
                                    <div className='table-responsive'>
                                        <table className='table-bordered tabela-relatorio w-100'>
                                            <thead style={{ background: "#BEBEBE" }}>
                                                <tr>
                                                    <th>PLANO DE TRABALHO</th>
                                                    <th>OPERADOR</th>
                                                    <th>INÍCIO DA EXECUÇÃO</th>
                                                    <th>FIM DA EXECUÇÃO</th>
                                                    <th>USUÁRIO AVALIAÇÃO OS</th>
                                                    <th>STATUS OS</th>
                                                    <th>DIVISÃO ADMINISTRATIVA</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {relatorio?.map((value, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr style={{background: "#e9e2e2"}}>
                                                            <td className="text-center">{value.planoTrabalho}</td>
                                                            <td className="text-center">{value.operador}</td>
                                                            <td className="text-center">{value.dataHoraExecucaoInicio}</td>
                                                            <td className="text-center">{value.dataHoraExecucaoFim}</td>
                                                            <td className="text-center">{value.usuarioAvaliacao}</td>
                                                            <td className="text-center">{value.statusAvaliacao}</td>
                                                            <td className="text-center">{value.divisaoAdministrativa}</td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>

                                                        {value?.listInconformidades?.map((inconformidade, index2) => (
                                                            <React.Fragment key={index2}>
                                                                {/* primeira linha */}
                                                                <tr>
                                                                    <td className="text-center" colSpan={2}>INCONFORMIDADE</td>
                                                                    <td className="text-center">DADOS ADICIONAIS</td>
                                                                    <td className="text-center">AÇÃO A SER EXECUTADA</td>
                                                                    <td className="text-center">USUÁRIO REGISTRO</td>
                                                                    <td className="text-center" colSpan={2}>DATA/HORA REGISTRO</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center" colSpan={2}>{inconformidade.inconformidade}</td>
                                                                    <td className="text-center">{inconformidade.dadosAdicionais}</td>
                                                                    <td className="text-center">{inconformidade.acaoAserExecutado}</td>
                                                                    <td className="text-center">{inconformidade.usuarioRegistro}</td>
                                                                    <td className="text-center" colSpan={2}>{inconformidade.dataHoraRegistro}</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                {/* segunda linha */}
                                                                <tr>
                                                                    <td className="text-center" >JUSTIFICATIVA</td>
                                                                    <td className="text-center">RESPONSÁVEL JUSTIFICATIVA</td>
                                                                    <td className="text-center">DATA/HORA JUSTIFICATIVA</td>
                                                                    <td className="text-center">AVALIAÇÃO</td>
                                                                    <td className="text-center">RESPONSÁVEL AVALIAÇÂO</td>
                                                                    <td className="text-center" colSpan={2}>DATA/HORA AVALIAÇÂO</td>
                                                                    <td className="text-center">USUÁRIO</td>
                                                                    <td className="text-center">RESPOSTA</td>
                                                                </tr>
                                                                <tr style={{borderBottom: (value?.listInconformidades.length == index2 + 1) ? "2px solid #CCC" : ""}}>
                                                                    <td className="text-center">{inconformidade.justificativa}</td>
                                                                    <td className="text-center">{inconformidade.usuarioResponsavel}</td>
                                                                    <td className="text-center">{inconformidade.dataHoraJustificativa}</td>
                                                                    <td className="text-center">{inconformidade.avaliacao}</td>
                                                                    <td className="text-center">{inconformidade.usuarioResponsavelAvaliacao}</td>
                                                                    <td className="text-center table-footer-row" colSpan={2}>{inconformidade.dataHoraAvaliacao}</td>
                                                                    <td className="text-center">{inconformidade.usuarioResposta}</td>
                                                                    <td className="text-center">{inconformidade.resposta}</td>
                                                                </tr>
                                                            </React.Fragment>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='print-footer w-100 mt-2' style={{ display: "none" }}>
                                    <p className='font-weight-bold text-right'>Gerado em {moment().format("DD/MM/YYYY HH:mm")}, Por {session?.nome}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </Row>
        </>
    );
}

export default RelatorioInconformidades;
